import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./index.css";
import Home from "./pages/HomePage";
import Privacy from "./pages/PrivacyPage";
import Terms from "./pages/TermsPage";
import Cookies from "./pages/CookiesPage";
import Subprocessors from "./pages/SubprocessorsPage";
import Security from "./pages/SecurityPage";
import PrivacyRequests from "./pages/PrivacyRequestsPage";
import Contact from "./pages/ContactPage";
import About from "./pages/AboutPage";
import Registration from "./pages/RegistrationPage";
import Faq from "./pages/FaqPage";
import Download from "./pages/DownloadPage";
import NotFound from "./pages/NotFoundPage";
import Merchants from "./pages/MerchantsPage";
import Riders from "./pages/RidersPage";
import Jobs from "./pages/JobsPage";

/**
 * Client-side navigation leaves the scroll position where it was. Reset to the
 * top on every route change, but honour in-page hash targets so anchor links
 * such as /faq#merchant-join still land on the right element.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

const WebRoutes = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/subprocessors" element={<Subprocessors />} />
      <Route path="/security" element={<Security />} />
      <Route path="/privacy-requests" element={<PrivacyRequests />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/registration" element={<Registration />} />
      <Route path="/download" element={<Download />} />
      <Route path="/merchants" element={<Merchants />} />
      <Route path="/riders" element={<Riders />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default WebRoutes;
